<template>
  <div class="cpm-wrapper">
    <div class="list">
      <p
        v-for="item in tabList"
        :key="item.value"
        @click="onClick(item)"
        :class="['tab-item', itemClass, item.tips && item.tips.length ? 'disabled' : '', activeVal === item.value ? 'active' : '']"
      >
        {{ item.label }}
        <HintIcon :tip="'以下店铺不支持' + item.label + '：' + item.tips.join('，')" v-if="item.tips && item.tips.length" />
      </p>
    </div>
  </div>
</template>

<script>
import HintIcon from '@/components/HintIcon.vue'

export default {
  components: { HintIcon },
  props: {
    activeVal: {
      type: Number,
      default: 0
    },
    tabList: {
      type: Array,
      default: () => []
    },
    itemClass: {
      type: String,
      default: ''
    }
  },
  mounted() {
    Telescope.trackEvent({
      trackId: 'zyb2bpc-event-ddy-ddqryzffsddj',
      custom: {
        PaymentMethod: this.activeVal === 103 ? 3 : this.activeVal === 0 ? 2 : 1, // 1/2/3 对公（2）/在线（0）/他人（103）
      }
    });
  },
  data() {
    return {};
  },
  methods: {
    onClick(item) {
      if (item.tips && item.tips.length) return

      Telescope.trackEvent({
        trackId: 'zyb2bpc-event-ddy-ddqryzffsddj',
        custom: {
          PaymentMethod: item.value === 103 ? 3 : item.value === 0 ? 2 : 1, // 1/2/3 对公（2）/在线（0）/他人（103）
        }
      });

      this.$emit('change', item);
    }
  }
};
</script>

<style lang="scss" scoped>
.cpm-wrapper {
  .list {
    .tab-item {
      width: 184px;
      height: 32px;
      font-size: 12px;
      border: 1px dashed #dedede;
      line-height: 32px;
      text-align: center;
      display: inline-block;
      margin-right: 8px;
      cursor: pointer;
      background: #fafafa;
    }
    .active {
      color: #1e8dff;
      border: 1px solid #1e8dff;
      background: #fff url('../../../assets/img/trian-right-icon.png') right bottom no-repeat;
      background-size: 17px 17px;
    }
    .disabled {
      background: #dedede;
      color: #909090;
      cursor: not-allowed;
    }
  }
}
</style>
